
//ARRAY => EN - NL - FR
export const routes = {
    "dashboard": ["", "dashboard", "tableau-de-bord"],
    "schedule": ["planning", "schedule", "planification"],
    "order_and_pickup": ["order-and-pickup", "bestellen-en-ophalen", "commandez-et-recuperez"],
    "track_and_trace": ["track-and-trace", "track-en-trace", "track-et-trace"],
};